import React, { useEffect } from 'react';

import modal from "../../../elements/ModalContainer/ModalContainer.module.scss";
import ModalContainer from '../../../elements/ModalContainer/ModalContainer';
import { Button } from '../../../elements';
import { showError, showSuccess } from '../../../elements/Toasts/toastActions';
import settings from "../../../pages/apps/Settings.module.scss";
import strings from '../../../lang/lang';
import {ErrorStatus, isProdModeAvailable} from '../../../api/portal/portalApi';
import {logout} from "../../auth/redux/authActions";
import { modalState, certificatesActions } from '../../../redux/reducers/certificates';
import { useAppSelector, useAppDispatch } from '../../../hooks/useRedux';

interface IModal {
  closeModal: (params: any) => void;
}

function RevokeCSR({ closeModal }: IModal) {
  const data = useAppSelector(modalState);
  const { certId, certCreationDate } = data;
  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      closeModal({});
    }
  }, [closeModal]);

  function revokeFile() {
    return new Promise((res, rej) => {
      dispatch(certificatesActions.revokeCSR({ id: certId, res, rej }));
    })
    .then(() => {
      showSuccess(strings.certificateContainer.text.successRevoke);
    })
    .catch(({ status, data }) => {
      if (data.message && !isProdModeAvailable(status, data.message)) {
        return;
      }
      if (401 === status) {
        logout();
      } else if (data.name && ErrorStatus.SESSION_OUTDATED === data.name) {
        closeModal({ name: 'show session outdata popup' });
      } else {
        showError(strings.certificateContainer.errors.revokingException)
      }
    })
    .finally(() => {
      closeModal({});
    });
  }

  return (
    <ModalContainer
      isOpen
      closeModalWindow={closeModal}
      title={strings.certificateContainer.text.revokeCertificateTitle}
    >
      <div className={modal['react-modal__btn-box']}>
        <div className={settings.settings__info_text}>
          <strong>
            {strings.certificateContainer.text.revokeCertificateQuestion} <br />{' '}
            {certCreationDate}?{' '}
          </strong>
          <p>{strings.certificateContainer.text.revokeCertificateDescription}</p>
        </div>
        <Button
          name={strings.certificateContainer.buttons.revoke}
          variant="primary"
          secondaryClassName="popup_primary"
          className="revoke"
          type="submit"
          onClick={() => revokeFile()}
        />
      </div>
      <Button
        name={strings.certificateContainer.buttons.cancel}
        variant="secondary"
        secondaryClassName="popup_secondary"
        type="button"
        onClick={closeModal}
      />
    </ModalContainer>
  );
}

export default RevokeCSR;
